/**
 * StepHeader Component
 * 
 * Header for wizard steps with title and description.
 */

import React from 'react';

export interface StepHeaderProps {
  /** Step title */
  title: string;
  /** Step description */
  description?: string;
  /** Additional CSS classes */
  className?: string;
}

export function StepHeader({ title, description, className = '' }: StepHeaderProps) {
  return (
    <div className={className}>
      <h3 className="text-lg font-medium text-gray-900 mb-4">{title}</h3>
      {description && (
        <p className="text-sm text-gray-600 mb-6">{description}</p>
      )}
    </div>
  );
}
